import React from 'react';
import oreganoBowl from '../../images/oregano.jpg';
import thymeIntro from '../../images/thyme-intro.jpg';
import chamomileIntro from '../../images/chamomile-intro.jpg';
import mountainTeaIntro from '../../images/mountain-tea-intro.webp';

const IntroSection = ({ t }) => {
  return (
    <section className="intro" id="intro">
      <div className="intro__dots" aria-hidden="true" />
      <div className="intro__content">
        <div className="intro__eyebrow">
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
        <h2>{t.intro.title}</h2>
        <p>{t.intro.body}</p>
      </div>
      <div className="intro__media">
        <div className="intro__image">
          <img src={oreganoBowl} alt="Ρίγανη σε μπολ" decoding="async" />
        </div>
        <div className="intro__stack">
          <div className="intro__thumb intro__thumb--thyme">
            <img src={thymeIntro} alt="Θυμάρι" loading="lazy" decoding="async" />
          </div>
          <div className="intro__thumb intro__thumb--chamomile">
            <img src={chamomileIntro} alt="Χαμομήλι" loading="lazy" decoding="async" />
          </div>
          <div className="intro__thumb intro__thumb--tea">
            <img src={mountainTeaIntro} alt="Τσάι του βουνού" loading="lazy" decoding="async" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
